var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner spinner-slices",style:({
    color: _vm.getTemplateOption('page_text_color'),
    borderColor: _vm.getTemplateOption('page_text_color'),
    '--page-text-color': _vm.pageTextColorRgb,
    '--spinner-size': _vm.size
  })})}
var staticRenderFns = []

export { render, staticRenderFns }